import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";

import styles from "./OlinkGuestPage.module.scss";
import { Logo } from "../../icons/logo";
import { useGuest } from "../../../providers/guest.provider";
import UserLinkHome from "../../ui/UserLinkHome/UserLinkHome";
import { useNavigate, useParams } from "react-router-dom";
import { GuestProfileDTO } from "../../../interfaces/guest.context";
import { getIconLink } from "../../../services/utilites.service";
import { setStyles } from "../../../services/personalization.service";
import { IPersonalizationContext } from "../../../interfaces/user.context";
import logo_light from "../../../assets/svg/logo-guest-white.svg";
import axios from "axios";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";
import SnackBar from "../../ui/SnackBar/SnackBar";

export interface IOlinkHome {
  isPreview?: boolean | null;
  onStopPreview?: () => void;
  profileId?: string;
  theme?: IPersonalizationContext;
  initialData?: any; // SSR data from backend
}

const OlinkGuestPage = (props: IOlinkHome) => {
  const params = useParams();
  const id = params.id ? params.id : "";
  const guest = useGuest();
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_MAIN_URL;
  const APP_URL = process.env.REACT_APP_BACK_URL || "https://theonly.link";

  const key = "pk_31b9b73cb71db2285b225a742af7f49744e1480d";

  // Initialize profile with SSR data if available
  const [profile, setProfile] = useState<GuestProfileDTO>(
    props.initialData || {
      id: null,
      links: [],
      userSocials: [],
      events: "",
    }
  );

  useEffect(() => {
    if (!id) return;
    
    if (id === "app") {
      navigate("/");
      return;
    }
    
    // Set guest.id for tracking
    guest.setId(id);
    
    // If we have SSR data - use it as initial placeholder for SEO
    if (props.initialData) {
      console.log('✅ Using SSR data as initial placeholder (SEO)');
      const processedData = { ...props.initialData };
      
      // Process prolink reordering
      if (processedData.links && Array.isArray(processedData.links) && processedData.links.length > 0) {
        const newArray = [...processedData.links];
        const proLinkIndex = newArray.findIndex((el: any) => el.type === "prolink");
        if (proLinkIndex !== -1) {
          const proLinkElem = newArray.splice(proLinkIndex, 1)[0];
          processedData.links = [proLinkElem, ...newArray];
        }
      }
      
      setProfile(processedData);
      console.log('📡 SSR placeholder set, now fetching FULL profile from API...');
      // ✅ НЕ РОБИМО return! Продовжуємо для API запиту
    }
    
    // Wait for guest.id to be set
    if (!guest.id) {
      console.log('⏳ Waiting for guest.id to be set...', { id, guestId: guest.id });
      return;
    }
    
    // ✅ ЗАВЖДИ робимо API запит для отримання ПОВНОЇ інформації (links, socials, etc.)
    console.log('📡 Fetching FULL profile from API:', id, { guestId: guest.id, hasSSR: !!props.initialData });
    guest.getGuest(true).then(
      async (res: any) => {
        console.log('✅ FULL profile fetched from API:', {
          id: res?.id,
          fullName: res?.fullName,
          linksCount: res?.links?.length || 0,
          socialsCount: res?.userSocials?.length || 0
        });
        if (res && res.links && Array.isArray(res.links) && res.links.length !== 0) {
          const result: any = [];
          guest.setPreviewImage(result);
          const newArray = [...res.links];
          const proLinkIndex = newArray.findIndex((el: any) => el.type === "prolink");
          if (proLinkIndex !== -1) {
            const proLinkElem = newArray.splice(proLinkIndex, 1)[0];
            res.links = [proLinkElem, ...newArray];
          }
          setProfile(res);
        } else {
          setProfile(res);
        }
      },
      (err) => {
        console.error('❌ Failed to fetch profile:', err);
        navigate("/404");
      }
    );
  }, [id, guest.id]); // ✅ Прибрано props.initialData з залежностей (використовується один раз як placeholder)
  
  // console.log(guest);
  // const [profile, setProfile] = useState<GuestProfileDTO>({
  //   id: null,
  //   links: [],
  //   userSocials: [],
  //   events: "",
  // });

  // if (props.theme) {
  //   setStyles(props.theme);
  // } else if (profile && profile.settings && profile.settings.theme) {
  //   setStyles(profile.settings?.theme);
  // }

  useEffect(() => {
    if (profile && profile.settings && profile.settings.theme) {
      setStyles(profile.settings?.theme);
    }
  }, [profile?.settings]);

  useEffect(() => {
    const fetchMediaLinks = async () => {
      if (!profile?.links || profile?.links.length === 0) return;

      try {
        const result: { url: string; id: any }[] = [];
        await Promise.all(
          profile.links.map(async (item: any) => {
            if (item.type === "audio" || item.type === "video") {
              try {
                const response = await axios.get(
                  `https://links.theonly.link/services/link-data/extract-v4-2?url=${item.currentUrl}`,
                  // `https://jsonlink.io/api/extract?url=${item.currentUrl}&api_key=${key}`,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      "Accept": "*",
                      // "Accept-Encoding": "gzip, deflate, br",
                      "Access-Control-Allow-Origin": "*",
                      "Access-Control-Allow-Methods": "GET",
                      "Access-Control-Allow-Headers": "Content-Type",
                      // "Access-Control-Allow-Credentials": "true",
                      "Cache-Control": "no-cache",
                      // "Host": "links.theonly.link",
                    },
                  }
                );

                if (
                  response?.data?.image !== undefined &&
                  response?.data?.image !== null
                    /*response?.data?.images?.length > 0*/
                ) {
                  const resUrl = response.data.image.replace(
                  // const resUrl = response.data.images[0].replace(
                    "http://",
                    "https://"
                  );
                  result.push({ url: resUrl, id: item.id });
                }
              } catch (err) {
                console.error("Error fetching data for item:", item, err);
              }
            }
          })
        );
        guest.setPreviewImage(result);
      } catch (error) {
        console.error("Error in Promise.all:", error);
      }
    };

    fetchMediaLinks();
  }, [profile]);

  return (
    <HelmetProvider>
      <div className={`main-content guest_page`}>
        <Helmet>
          <title>{profile?.title}</title>
          <meta
            name="og:title"
            content={profile?.title}
            data-react-helmet="true"
          />
          <meta
            name="description"
            content={profile?.description}
            data-react-helmet="true"
          />
          <meta
            property="og:description"
            content={profile?.description}
            data-react-helmet="true"
          />
          <meta property="og:type" content="page" data-react-helmet="true" />
          <meta
            property="og:site_name"
            content={profile?.fullName}
            data-react-helmet="true"
          />
          <meta
            property="og:url"
            content={`${APP_URL}/app/${profile?.nickname}`}
            data-react-helmet="true"
          />
          <meta
            property="twitter:site"
            content={profile?.fullName}
            data-react-helmet="true"
          />
          <meta
            property="twitter:text:title"
            content={profile?.title}
            data-react-helmet="true"
          />
          <meta
            property="twitter:description"
            content={profile?.description}
            data-react-helmet="true"
          />
          {/* OG */}
        </Helmet>
        <div
          className={`${styles.home} ${styles.guest_page} guest_page home ${profile?.settings?.theme?.themeName} `}
        >
          <div
            className={`${styles.container} container container_xs `} //${profile?.links === undefined ? "grid-disabled" : ""}
            style={{
              ...(profile?.links?.length === 0
                ? { gridTemplateColumns: 0 }
                : {}),
            }}
          >
            <div
              className={`${
                profile?.links && profile?.links.length > 0
                  ? ""
                  : styles.merged_cells
              } `}
            >
              <div className={styles.guest_page__col}>
                <Stack direction="column" spacing={1} className="avatar mb-10">
                  <Avatar alt="User" src={profile?.avatar?.url} />
                  <h1 className="name ff-gilroy fw-700">{profile?.fullName}</h1>
                </Stack>

                {profile?.interest ? (
                  <h5 className="interest fw-400 ff-gilroy text-center mb-15">
                    {profile?.interest ? profile?.interest?.name : ""}
                  </h5>
                ) : null}

                {profile?.location ? (
                  <p className="location fw-400 ff-gilroy text-center mb-20">
                    <svg width="14" height="18" viewBox="0 0 14 18" fill="none">
                      <path d="M10.8306 11.9017L11.403 12.3048L10.8306 11.9017ZM3.16903 11.9017L2.59672 12.3048H2.59672L3.16903 11.9017ZM3.6665 12.6178L3.08623 13.0093L3.08623 13.0093L3.6665 12.6178ZM6.29298 16.0882L5.75862 16.5403L6.29298 16.0882ZM7.7067 16.0882L8.24106 16.5403L8.24106 16.5403L7.7067 16.0882ZM10.3332 12.6178L9.7529 12.2263H9.7529L10.3332 12.6178ZM12.1332 7.48652C12.1332 8.1165 11.919 8.77245 11.5623 9.46191C11.2047 10.153 10.7328 10.8249 10.2583 11.4986L11.403 12.3048C11.8673 11.6454 12.3967 10.8956 12.8057 10.1053C13.2155 9.3134 13.5332 8.42831 13.5332 7.48652H12.1332ZM6.99984 2.2C9.81791 2.2 12.1332 4.54964 12.1332 7.48652H13.5332C13.5332 3.81087 10.6251 0.8 6.99984 0.8V2.2ZM1.8665 7.48652C1.8665 4.54964 4.18177 2.2 6.99984 2.2V0.8C3.37458 0.8 0.466504 3.81087 0.466504 7.48652H1.8665ZM3.74134 11.4986C3.26685 10.8249 2.79498 10.153 2.43739 9.46191C2.08063 8.77245 1.8665 8.1165 1.8665 7.48652H0.466504C0.466504 8.42831 0.784217 9.3134 1.194 10.1053C1.60296 10.8956 2.13235 11.6454 2.59672 12.3048L3.74134 11.4986ZM4.24678 12.2263C4.08546 11.9872 3.91301 11.7424 3.74134 11.4986L2.59672 12.3048C2.77004 12.5509 2.93416 12.7839 3.08623 13.0093L4.24678 12.2263ZM6.82734 15.636C6.20653 14.9023 5.24205 13.7014 4.24678 12.2263L3.08623 13.0093C4.11725 14.5374 5.1148 15.7795 5.75862 16.5403L6.82734 15.636ZM7.17233 15.636C7.07749 15.7481 6.92219 15.7481 6.82734 15.636L5.75862 16.5403C6.41269 17.3133 7.58698 17.3133 8.24106 16.5403L7.17233 15.636ZM9.7529 12.2263C8.75763 13.7014 7.79315 14.9023 7.17233 15.636L8.24106 16.5403C8.88488 15.7795 9.88242 14.5374 10.9134 13.0093L9.7529 12.2263ZM10.2583 11.4986C10.0867 11.7424 9.91422 11.9872 9.7529 12.2263L10.9134 13.0093C11.0655 12.7839 11.2296 12.5509 11.403 12.3048L10.2583 11.4986ZM8.79984 7.48651C8.79984 8.5341 7.97696 9.35216 6.99984 9.35216V10.7522C8.78414 10.7522 10.1998 9.27286 10.1998 7.48651H8.79984ZM6.99984 5.62086C7.97696 5.62086 8.79984 6.43893 8.79984 7.48651H10.1998C10.1998 5.70016 8.78414 4.22086 6.99984 4.22086V5.62086ZM5.19984 7.48651C5.19984 6.43893 6.02272 5.62086 6.99984 5.62086V4.22086C5.21553 4.22086 3.79984 5.70016 3.79984 7.48651H5.19984ZM6.99984 9.35216C6.02272 9.35216 5.19984 8.5341 5.19984 7.48651H3.79984C3.79984 9.27286 5.21553 10.7522 6.99984 10.7522V9.35216Z" />
                    </svg>
                    {profile?.location}
                  </p>
                ) : null}

                <div
                  className={`social-platforms-links guest_page justify-content-center flex-wrap`}
                >
                  {profile?.userSocials && Array.isArray(profile.userSocials) && profile.userSocials.map((item, index) => {
                    return item.selected ? (
                      <a
                        className={`social-platforms-links__item flex-center-center social_icon_home`}
                        href={
                          item.name === "Email"
                            ? `mailto:${item?.currentUrl}`
                            : item?.currentUrl
                        }
                        ping={item?.url}
                        key={index}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          className={"social-platforms-links__icon"}
                          src={getIconLink(item?.name)}
                          alt={item.name}
                        />
                      </a>
                    ) : null;
                  })}
                </div>
              </div>
            </div>

            <div className="home_cards guest_page">
              {profile?.links
                ?.sort((a, b) => a.order! - b.order!)
                .map((item, index) => {
                  return (
                    <UserLinkHome
                      preview={guest?.previewImage?.find((el: any) =>
                        el.id === item.id ? el.url : ""
                      )}
                      link={item}
                      role={""}
                      key={"user_link_" + index}
                      index={index}
                      onReorder={() => {}}
                      onVisible={() => {}}
                      onDelete={() => {}}
                    />
                  );
                })}
            </div>

            {!profile?.settings?.theme.statusLogo && (
              <>
                {profile?.settings?.theme.btn_white ? (
                  <img
                    className={`logoHome ${styles.merged_cells}`}
                    src={logo_light}
                    alt="the only link logo"
                  />
                ) : (
                  <a
                    style={{ marginRight: 30 }}
                    href={APP_URL + "/app/auth/signup" + (id ? "?prof=" + id : "")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Logo.mainLogo className={styles.merged_cells} />
                  </a>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <SnackBar />
    </HelmetProvider>
  );
};

export default OlinkGuestPage;
